import Vue from "vue";
import Vuex from "vuex";
import { user_store } from "@/store/user/user";
import { app_store } from "@/store/app/app";
import { StateUser } from "@/store/user/types_user";
import { StateApp } from "@/store/app/types_app";
import { StateFormEmail } from "@/store/formEmail/types_formEmail";
import { formEmail_store } from "@/store/formEmail/formEmail";

Vue.use(Vuex);

export interface RootState {
  user_module: StateUser;
  app_module: StateApp;
  formEmail_module: StateFormEmail;
}

export default new Vuex.Store({
  modules: {
    user_module: user_store,
    app_module: app_store,
    formEmail_module: formEmail_store,
  },
});
